import { Injectable, inject } from '@angular/core';

import { BetslipQdApiService } from './betslipqd-api.service';
import { DepositService } from './deposit.service';

@Injectable({
    providedIn: 'root',
})
export class CcDepositSubmitService {
    private apiService = inject(BetslipQdApiService);
    private depositService = inject(DepositService);

    submitCCDeposit(cvv2: any, paymentAccountUpdateUrl: string, callback: (error: any) => void, cardToken?: string) {
        const requestData = { cvv: cvv2 };

        this.apiService.postPgwRequest(paymentAccountUpdateUrl, requestData, cardToken).subscribe(
            (data) => {
                if (data) this.depositService.submitDeposit();
            },
            (error) => callback(error),
        );
    }
}
